import type React from "react";
import { ReactComponent as Svg } from "./assets/icon-facebook.svg";
import * as styles from "./Icon.module.scss";

type FacebookProps = React.SVGProps<SVGSVGElement>;

export const Facebook = ({ className, ...props }: FacebookProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
